import React from "react";
import { DetailRow, DetailSection } from "../../../ui/DetailRow";
import { StatusBadge } from "../../../ui";
import {
  Building2, Mail, Phone, MapPin, Hash, Globe, Calendar,
} from "lucide-react";

/**
 * OverviewTab — General info about the institute.
 */
const OverviewTab = ({ institute }) => {
  const inst = institute;

  return (
    <div className="sa-detail-tab">
      <DetailSection title="Basic Information">
        <DetailRow icon={Building2} label="Name" value={inst.name} />
        <DetailRow icon={Mail} label="Email" value={inst.email} />
        <DetailRow icon={Phone} label="Phone" value={inst.phone} />
        <DetailRow icon={MapPin} label="Address" value={inst.address} />
        <DetailRow icon={Globe} label="Currency" value={inst.currency || "INR"} />
        <DetailRow icon={Hash} label="GST Number" value={inst.gstNumber} />
        <DetailRow
          icon={Calendar}
          label="Registered"
          value={inst.createdAt ? new Date(inst.createdAt).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric", timeZone: "Asia/Kolkata" }) : "—"}
        />
        <DetailRow
          label="Status"
          value={<StatusBadge status={inst.status || "active"}>{inst.status || "Active"}</StatusBadge>}
        />
      </DetailSection>

      <DetailSection title="Invoice Configuration">
        <DetailRow label="Invoice Prefix" value={inst.invoicePrefix || "INV"} />
        <DetailRow label="Receipt Prefix" value={inst.receiptPrefix || "RCP"} />
        <DetailRow label="Invoice Counter" value={inst.invoiceCounter ?? 0} />
      </DetailSection>
    </div>
  );
};

export default OverviewTab;
